<div class="timeline-container">
  <h2 class="timeline-title">LTI 1.3 Tool Integration Flow</h2>
  <p class="timeline-subtitle">Follow these steps to integrate any LTI Tool with this LTI Platform</p>
  
  <p-timeline [value]="timelineEvents" align="alternate" styleClass="customized-timeline">
    <ng-template #marker let-event>
      <span class="timeline-marker" [style.backgroundColor]="event.color">
        <i [class]="event.icon"></i>
      </span>
    </ng-template>
    <ng-template #content let-event>
      <p-card [header]="'Step ' + event.step + ': ' + event.title" [style]="{'border-left': '3px solid ' + event.color}">
        <p class="timeline-event-description">{{ event.description }}</p>
        @if (event.step === 1) {
          <div class="timeline-actions">
            <p-button label="What Tool Credentials do you need?" icon="pi pi-info-circle" severity="secondary" size="small" (click)="showDialog()" styleClass="mr-2" />
            <p-button label="Go to Add Tool" icon="pi pi-hammer" severity="primary" size="small" (click)="goToAddTool()" styleClass="mr-2" />
          </div>
        }
        @if (event.step === 3) {
          <div class="timeline-actions">
            <p-button label="Which Platform Credentials?" icon="pi pi-info-circle" severity="secondary" size="small" (click)="goToViewToolsPage()" styleClass="mr-2" />
          </div>
        }
        @if (event.step === 5) {
          <div class="timeline-actions">
            <p-button label="Deep Linking" icon="pi pi-link" severity="info" size="small" styleClass="mr-2" (click)="goToDeeplinkPage()" />
            <p-button label="Test Launch" icon="pi pi-external-link" severity="secondary" size="small" (click)="goToDeeplinkPage()" />
          </div>
        }
      </p-card>
    </ng-template>
  </p-timeline>
</div>
<p-dialog header="Tool Credentials" [modal]="true" [(visible)]="toolCredentialsDialogVisible" [style]="{ width: '25rem' }">
        <p class="p-text-secondary mb-3">You will need the following credentials from the Tool provider:</p>
        <ul class="credentials-list">
            <li><i class="pi pi-globe mr-2"></i>Tool URL</li>
            <li><i class="pi pi-key mr-2"></i>Public Keyset URL</li>
            <li><i class="pi pi-sign-in mr-2"></i>Initiate Login URL</li>
            <li><i class="pi pi-directions mr-2"></i>Redirect URL</li>
            <li><i class="pi pi-question-circle mr-2"></i>Does it support Deep Linking?</li>
            <li><i class="pi pi-link mr-2"></i>If yes, then Deep Linking URL</li>
        </ul>
        <div class="flex justify-end gap-2 mt-3">
            <p-button label="Copy" icon="pi pi-copy" severity="info" (click)="copyCredentialsToClipboard()" />
            <p-button label="Ok" severity="secondary" (click)="toolCredentialsDialogVisible = false" />
        </div>
</p-dialog>
